// @flow
export { default } from "lodash/fp/isEmpty"
